import { useState, useEffect, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import styles from "./LeadCaptureReports.module.css"

// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faSquareCheck, faSquareXmark } from '@fortawesome/free-solid-svg-icons'

//https://github.com/recharts/recharts

// image elements
const pencil = <FontAwesomeIcon icon={faPencil} />
const squareCheck = <FontAwesomeIcon icon={faSquareCheck} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} />

const LeadCaptureReports = ({ user }) => {

    
    return (
        <div className="page-area">
            <h1>LeadCaptureReports</h1>

          
        </div>
    );
}

export default LeadCaptureReports;